import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { EmptyState } from '../../../components';
import { useGetFoldersQuery } from '../../../services';
import FolderTreeColumn from './FolderTreeColumn';

interface SimulationsExplorerProps {
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}

const SimulationsExplorer = ({ setIsLoading }: SimulationsExplorerProps) => {
  // The simulation that is currently being viewed.
  // Defined here because only 1 simulation can be open at a time.
  const [openSimulationId, setOpenSimulationId] = useState<string | null>(null);

  const { data: rootFolder, isLoading: isRootFolderLoading } = useGetFoldersQuery({});

  const subFolders = rootFolder?.subFolders || [];
  const isEmpty = !subFolders.length && !isRootFolderLoading;

  useEffect(() => {
    setIsLoading(isRootFolderLoading);
  }, [isRootFolderLoading, setIsLoading]);

  if (isEmpty) {
    return <EmptyState description="No simulations created yet" />;
  }

  return (
    <div className="flex h-full overflow-x-auto overflow-y-hidden border-t bg-base-100 shadow-dialog">
      <FolderTreeColumn
        folders={subFolders}
        isLoading={isRootFolderLoading}
        openSimulationId={openSimulationId}
        prospects={[]} // The root folder does have any prospects.
        setOpenSimulationId={setOpenSimulationId}
      />
    </div>
  );
};

export default SimulationsExplorer;
